import * as React from 'react';
import { Container, Grid, Typography } from '@mui/material';
import CardProduct from '../components/CardProduct';

export default function Works() {

    return (  
        <Container sx={{ marginTop:4, marginBottom:4 }}>                               
            <Grid container spacing={4}>
                <Grid size={12}>
                    <Typography variant='h3' fontWeight={'bold'} sx={{ textAlign: 'center' }}>Trabajos realizados</Typography>
                </Grid>
                <Grid size={{ sm: 12, md: 6, lg: 6 }} sx={{ display: 'flex', justifyContent: 'center' }}>                   
                    <CardProduct img='Gaviotas.webp' title='Gaviota 2500' 
                    video='https://youtube.com/watch?v=UMIcvqLhveY'
                    description='Centro de mecanizado de 4 ejes comandados por CNC diseñado para el 
                    trabajo sobre perfiles de aluminio y PVC.' />                  
                </Grid>
                <Grid size={{ sm: 12, md: 6, lg: 6 }} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CardProduct img='Doble cabezal.webp' title='Doble cabezal'
                    video='https://www.youtube.com/watch?v=3ePjotdgngU'
                    description='Sierra de corte CNC de doble cabezal con inclinación (90º/45º) 
                    totalmente automática.' />
                </Grid>
                <Grid size={{ sm: 12, md: 6, lg: 6 }} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CardProduct img='IBIS.webp' title='IBIS' 
                    video='https://www.youtube.com/watch?v=UhMkaRmVlHc'
                    description='Router vertical CNC para corte, seccionado y mecanizado de aluminio 
                    compuesto (Alucobond), madera, policarbonato, acrílico u otros materiales no 
                    ferrosos en plancha.' />
                </Grid>
                <Grid size={{ sm: 12, md: 6, lg: 6 }} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CardProduct img='A3000.webp' title='A3000' 
                    video='https://www.youtube.com/watch?v=eJugeIlBqjU'
                    description='Centro de mecanizado de 8 ejes comandados por CNC diseñado para el 
                    trabajo sobre perfiles de aluminio y PVC.'  />
                </Grid>
            </Grid>
        </Container> 
    )
}